import { render, staticRenderFns } from "./ChoirSelect.vue?vue&type=template&id=93aa0a34&scoped=true&"
import script from "./ChoirSelect.vue?vue&type=script&lang=ts&"
export * from "./ChoirSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93aa0a34",
  null
  
)

export default component.exports